/**
 * FT-122d: Docs & Compliance Module
 *
 * Simplified to single-view: Compliance Register with Documents Folder link.
 * No tab bar needed - ComplianceRegisterTab handles everything.
 *
 * FT-354a: forwards setActiveModule down as an onBack handler so
 * ComplianceRegisterTab can render a mobile back button that returns to the
 * dashboard (mobile viewport otherwise has no way out of this screen).
 */

import React, { useCallback } from 'react';
import ComplianceRegisterTab from './policies/ComplianceRegisterTab';
// FT-357: shell-level back handler — register a "back to dashboard" handler
// so mobile users always see a Back button in the bottom bar.
import { useSetBackHandler } from '../../../contexts/NavigationBackContext';

const PoliciesModule = ({ setActiveModule }) => {
  // FT-354a: return to dashboard when the mobile back button fires.
  const handleBack = setActiveModule ? () => setActiveModule('dashboard') : undefined;

  // FT-357: register a shell-level "back to dashboard" handler so mobile
  // users always see a Back button in the bottom bar for this module.
  // (Note: ComplianceRegisterTab already registers its own handler via
  // the onBack prop above — this module-level registration is defensive
  // for the case where the tab hasn't mounted its handler yet or the
  // registration is somehow torn down.)
  useSetBackHandler(
    useCallback(() => {
      if (setActiveModule) setActiveModule('dashboard');
    }, [setActiveModule])
  );

  return (
    <div>
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Docs & Compliance</h1>
        <p className="mt-1 text-sm text-gray-500">
          Track certificates, documents, and regulatory compliance
        </p>
      </div>

      {/* FT-122d: Single view - ComplianceRegisterTab handles everything */}
      <ComplianceRegisterTab onBack={handleBack} />
    </div>
  );
};

export default PoliciesModule;
